<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2026 (original work) Open Assessment Technologies SA ;

    import { modalStore } from '@/stores/modal.store.js';
</script>

{#if $modalStore.isOpen && $modalStore.component}
    <svelte:component this={$modalStore.component} {...$modalStore.props} on:close={modalStore.close} />
{/if}
